<button mat-icon-button [matMenuTriggerFor]="userActions" matTooltip="Hilfemenü öffnen" [matTooltipShowDelay]="500">
    <mat-icon class="relative" svgIcon="mat_outline:help_outline"></mat-icon>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item (click)="openWebsite(helpUrl)">
        <mat-icon svgIcon="mat_outline:help_center"></mat-icon>
        <span>Hilfe</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="openWebsite('https://www.ailotse.com/')">
        <mat-icon svgIcon="mat_outline:info"></mat-icon>
        <span>Über uns</span>
    </button>
</mat-menu>
